Ext.define('SA.lq.view.LocationCellMenuItemsFactory', {
    constructor({getCaptionHtml, canAddToProject, canAddToFavorites}) {
        this.getCaptionHtml = getCaptionHtml;
        this.canAddToProject = canAddToProject;
        this.canAddToFavorites = canAddToFavorites;
    },

    getItems({locationInfo: {locationSeries, name, alias}, handlers}) {
        return [
            {
                xtype: 'component',
                cls: 'sa-report-grid-menu-caption',
                html: this.getCaptionHtml({name, alias})
            }, {
                xtype: 'menuitem',
                text: 'Add to Project',
                disabled: !this.canAddToProject(locationSeries),
                handler: () => handlers.addToProject()
            }, {
                xtype: 'menuitem',
                text: SA.localize('Add to Favorites'),
                hidden: !this.canAddToFavorites(locationSeries),
                handler: () => handlers.addToFavorites()
            }, {
                xtype: 'menuitem',
                text: SA.localize('Remove from Favorites'),
                hidden: this.canAddToFavorites(locationSeries),
                handler: () => handlers.removeFromFavorites()
            }, {
                xtype: 'menuitem',
                text: 'Add Alias Location Name',
                hidden: alias !== null,
                handler: () => handlers.addAlias()
            }, {
                xtype: 'menuitem',
                text: 'Edit Alias Location Name',
                hidden: alias === null,
                handler: () => handlers.editAlias()
            }
        ];
    }
});